import { render } from "./SubsidiesColumns.vue?vue&type=template&id=696dd4a0&scoped=true"
import script from "./SubsidiesColumns.vue?vue&type=script&lang=js"
export * from "./SubsidiesColumns.vue?vue&type=script&lang=js"

import "./SubsidiesColumns.vue?vue&type=style&index=0&id=696dd4a0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696dd4a0"]])

export default __exports__